import { useRef } from 'react';
import ReactEcharts from 'echarts-for-react';
import { useTranslation } from 'react-i18next';

import { useGroupEventsSummary } from '../../modules/organisation/hooks/useGroupStats';
import HomeCard from './HomeCard';
import { getChartLabelColor } from '../lib/utils';
import useElementWidth from '../../hooks/useElementWidth';
import useDeviceStatusFilter from '../../modules/equipment/hooks/useDeviceStatusFilter';

const LG_BREAKDOWN = 620;
const SM_BREAKDOWN = 410;

function EventStatus() {
  const { t } = useTranslation();
  const eventsSummary = useGroupEventsSummary();
  const cardRef = useRef(null);
  const width = useElementWidth(cardRef.current);
  const { filterAll } = useDeviceStatusFilter();

  const chartOptions = {
    legend: width <= SM_BREAKDOWN ? {
      orient: 'horizontal',
      left: 'center',
      top: 'bottom',
      textStyle: {
        fontSize: 10,
      }
    }: {
      orient: 'vertical',
      left: 'left',
      top: 'top',
      textStyle: {
        fontSize: 12,
      }
    },
    center:
      width >= LG_BREAKDOWN ? ['50%', '50%'] :
        width <= SM_BREAKDOWN ? ['50%', '35%'] :
          ['66%', '50%'],
    radius: width <= SM_BREAKDOWN ? ['25%', '60%'] : ['30%', '70%']
  };

  if(!eventsSummary) return null;

  const { items = [], _state_: {loading, error} = {} } = eventsSummary || {};

  return (
    <div ref={cardRef}>
      <HomeCard
        header={t('user.Fleet_Status')}
        headerLink={{ to: '/equipment', text: t('home.all-equipment'), onClick: () => filterAll() }}
        loading={loading}
        error={error}
      >
        <ReactEcharts
          option={{
            tooltip: {
              formatter: params => `${t(params.data.name)}: ${params.percent}%`,
              position: (pos) => ({
                left:pos[0] + 10,
                top: pos[1]
              })
            },
            legend: {
              ...chartOptions.legend,
              data: items.map(item => item.key),
              formatter: item => t(item),
            },
            series: {
              name: "user.Fleet_Status",
              type: 'pie',
              height: 300,
              radius: chartOptions.radius,
              center: chartOptions.center,
              avoidLabelOverlap: false,
              label: {
                normal: {
                  show: false,
                  position: 'center'
                }
              },
              color: items.map(item => getChartLabelColor(item.color)),
              data: items.map(item => ({
                value: item.count,
                name: item.key,
              }))
            }
          }}
        />
      </HomeCard>
    </div>
  );
}

export default EventStatus;